export default __webpack_public_path__ + "static/media/pic4.cec59d0c.jpg";